const localizedPartners = ['telus', 'koodo'];

const isPartnerLocalizable = (partner: string) =>
    localizedPartners.includes(partner);

export default isPartnerLocalizable;
